import { IconOption } from 'rwl-shared/dist/models';
import { IconSymbol, Icons } from 'rwl-ui';

export function determineIconForWorkSite(
    configOption: IconOption
): IconSymbol | undefined {
    return labelToIconMap[configOption] ?? Icons.HOUSE_ICON;
}

// FIFO, first match wins.  If you have a special icon for a JobService put it before the icon for the parent Service
const labelToIconMap: Record<IconOption, IconSymbol> = {
    house: Icons.HOUSE_ICON,
    pointerDark: Icons.PIN_DARK,
    pointerLight: Icons.PIN_LIGHT,
};
